import { render, staticRenderFns } from "./EditALesson.vue?vue&type=template&id=0ab91cf7"
import script from "./EditALesson.vue?vue&type=script&lang=js"
export * from "./EditALesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports